import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import CloseIcon from "@material-ui/icons/Close";
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader/index';
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import "../../../../_metronic/_assets/plugins/flaticon2/flaticon.css";

const useStyles = makeStyles({
  list: {
    width: 400,
    height: "100vh"
  },
  card: {
    margin: "30px"
  },
  pointer: {
    cursor: 'pointer'
  }
});

export default function View(props) {
  const { onClose, asset } = props;
  const {
    name,
    contactPerson,
    contactPersonPhoneNumber,
    contactPersonEmail,


  } = asset;
  const classes = useStyles();
  const sideList = side => (
    <div
      className={classes.list}
      role="presentation"
    >
      <div className="col-12 d-flex align-items-center justify-content-between py-4">
        <h1 className="h3 mb-0">Asset details</h1>
        <CloseIcon className={classes.pointer} onClick={onClose} />
      </div>
      <Divider className="bg-dark" />
      <div className="drawer-body">
        <Card className={classes.card}>
          <CardHeader
            title="General information"
            className="bg-secondary text-dark h6 p-3"
            disableTypography
          />
          <CardHeader
            avatar={
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/Communication/Address-card.svg"
                )}
                className="icon-primary"
              />
            }
            title={name}
            subheader="Asset Name"
            className="p-3"
          />
          <CardHeader
            avatar={
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/Communication/Address-card.svg"
                )}
                className="icon-primary"
              />
            }
            title={contactPerson}
            subheader="Contact Person"
            className="p-3"
          />
          <CardHeader
            avatar={
              <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Call.svg")} className="icon-primary" />
            }
            title={contactPersonPhoneNumber}
            subheader="Contact Person Phone Number"
            className="p-3"
          />
          <CardHeader
            avatar={
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Communication/Mail.svg")}
                className="icon-primary"
              />
            }
            title={contactPersonEmail}
            subheader="Contact Person Email"
            className="p-3"
          />
        </Card>
      </div>
    </div>
  );

  return (
    <Drawer {...props} anchor="right" className="drawer--fixed">
      {sideList('right')}
    </Drawer>
  );
}
